import React, { useState, Fragment, useEffect } from "react"
import SvgIcon from '@material-ui/core/SvgIcon';

import * as api from '../../api/apiFunc' 
import * as R from 'ramda'

const ListIcons = ({ icons, iconsapp, access,filtered, handleOnClick, nodiv,classnam, dopargs }) =>  {
  const [txtval, Settxtval] = useState("");
  const handleChange = e => {
    let val = e.target.value
  }
  const ParseSvgFilePath = (svgfile) => {
    const arr = svgfile.split('>')
    const path = arr[1].slice(9, -2)
    //на скорую руку потом делать
    return {d:path}
 }

 const PrepareIcon = (id) => {
     const iconfile = R.find(R.propEq('ui_app_icon_id', id))(iconsapp)
     if (!api.isEmpty(iconfile)) {
         const icontype = iconfile.ui_app_icon_file.indexOf('svg') == -1 ? 'JPEG' : 'SVG' //  R.find(R.propEq('ui_app_icon_type_id', iconfile.ui_app_icon_type_id))(iconstype)
         if (!api.isEmpty(icontype)) {
           if (icontype == 'SVG') {
             const svgpath = ParseSvgFilePath(iconfile.ui_app_icon_file)
             return (
               {
                 id, type: icontype, file: svgpath,
                 style: { "float": "left", "fontSize": 24, "color": "#6e767d" }
               })
           }
           else { 
             const file = `data:image/jpeg;base64,${iconfile.ui_app_icon_file}`
             return (
               {
                 id, type: icontype, file,
                 style: { "float": "left", "fontSize": 24, "color": "#6e767d" }
               })
           }
         }
     }
  }
  const OneIcon = (props) => {
    const iconapp = R.find(R.propEq('ui_app_icon_id', props.id))(iconsapp)
    const useraccess = access[iconapp.ui_app_icon_mnem] 
    if (useraccess == -1) return null
    let accessstyle = (useraccess == 0 ? { opacity: '0.4',cursor: 'default' } : {})
    if (props.id == 20) accessstyle = { ...accessstyle, color: 'red' }
    const title = (api.isNotEmptyArr(props.title) ? props.title[useraccess] : props.title)
    const icon = PrepareIcon(props.id)
    if (icon.type == 'SVG') {
      if (nodiv) {
        return (<SvgIcon className={classnam} style={{ ...accessstyle }} onClick={() => (useraccess != 0 ? handleOnClick(props.id) : null)}>
          {/*iconapp.path.map(icon => <path {...icon} />)*/}
          <path {...icon.file} />
        </SvgIcon>)
      }
      return (<div title={title}><SvgIcon className={classnam} style={{ ...accessstyle }} onClick={() => (useraccess != 0 ? handleOnClick(props.id,dopargs) : null)}>
        {/*iconapp.path.map(icon => <path {...icon} />)*/}
        <path {...icon.file} />
      </SvgIcon></div>)
    }
    else {
      if (nodiv) {
        return (
          <div className = "img-block"><div> <img src={icon.file} style={{...props.style, ...accessstyle }} /> </div></div>
          )
       }
      return (
        <div><div title={title}> <img src={icon.file} style={{...props.style, ...accessstyle }} /> </div></div>
        )
     }
  }
    
    
  if (!icons) return null       
  return (
        <Fragment>
          {icons.sort((a, b) => a.order - b.order).map((el) => {
              const iconapp = R.find(R.propEq('ui_app_icon_id', el.id))(iconsapp) 
            if (iconapp && (iconapp.ui_app_icon_mnem == "save" || iconapp.ui_app_icon_mnem == "add" || iconapp.ui_app_icon_mnem == (filtered == true ? "filter" : "filteroff") || iconapp.ui_app_icon_mnem == "delete"
            || iconapp.ui_app_icon_mnem == "nofilt" || iconapp.ui_app_icon_mnem=="search" || iconapp.ui_app_icon_mnem=="apps" ))
              return <OneIcon key={el.id} {...el} />
          }
          )}
        </Fragment>
    );
}

export default ListIcons